/*
*   List of Action IDs that should be passed from accreditation.reducer.js to master-doc-list.reducer.js
 */

export const IDS = {
    masterDocList: 'masterDocList',

    //paths
    masterDocListGrid:             'masterDocListGrid',
    masterDocListDetails:          'masterDocListDetails',
    masterDocListExport:           'masterDocListExport',
    masterDocListVersions:         'masterDocListVersions',
    masterDocListVersionsGrid:     'masterDocListVersionsGrid',
    masterDocListRequirementsGrid: 'masterDocListRequirementsGrid',

    // states
    app_accreditation_scheme_master_doc_list:         'app.accreditation.scheme.master-doc-list',

    // tab states:
    app_accreditation_scheme_master_doc_list_list:    'app.accreditation.scheme.master-doc-list.list',
    app_accreditation_scheme_master_doc_list_export:  'app.accreditation.scheme.master-doc-list.export',
    app_accreditation_scheme_master_doc_list_details: 'app.accreditation.scheme.master-doc-list.details',
    app_accreditation_scheme_master_doc_list_versions:'app.accreditation.scheme.master-doc-list.versions',
};